
    import {
        defineComponent, ref, unref, PropType,
    } from 'vue';
    import CommonButton from '@ve/components/button/desktop/Button.vue';
    import formatNumber from '@/js/common/Domain/Service/mixins/formatNumber';
    import { IReturnProductRailways } from '@ve/pages/hotel/types';
    import useProduct from '@ve/pages/hotel/use/useProduct';
    import NightDifference from '@fr/vue/components/nightDiffrence/NightDifference.vue';
    import ProductPrepayment from './components/ProductPrepayment.vue';

    export default defineComponent({
        components: {
            CommonButton,
            ProductPrepayment,
            NightDifference,
        },
        methods: {
            formatNumber,
        },
        props: {
            railwayProducts: {
                type: Array as PropType<IReturnProductRailways[]>,
                default: [],
            },
        },
        setup(props, { emit }) {
            const { railwayProducts } = props;
            const open = () => {
                emit('click');
            };

            return {
                open,
                ...useProduct<IReturnProductRailways>(railwayProducts),
            };
        },
    });
